import { c as _c } from "react/compiler-runtime";
import { CREDITS_BALANCE } from "@src/constants/credit-constants";
import { companyCreditBalanceSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect, useState } from "react";
/** Custom hook to have util function related to token purchase */
export function useTokenPurchase() {
  const $ = _c(5);
  const companyCreditBalance = useAppSelector(companyCreditBalanceSelector);
  const [shouldShowNewIndication, setShouldShowNewIndication] = useState(false);
  let t0;
  let t1;
  if ($[0] !== companyCreditBalance) {
    t0 = () => {
      const currentBalance = localStorage.getItem(CREDITS_BALANCE);
      if (!currentBalance) {
        return;
      }
      const balanceAmount = parseFloat(currentBalance);
      if (balanceAmount >= companyCreditBalance) {
        setShouldShowNewIndication(true);
      } else {
        if (balanceAmount < companyCreditBalance) {
          localStorage.removeItem(CREDITS_BALANCE);
          setShouldShowNewIndication(false);
        }
      }
    };
    t1 = [companyCreditBalance];
    $[0] = companyCreditBalance;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== shouldShowNewIndication) {
    t2 = {
      shouldShowNewIndication
    };
    $[3] = shouldShowNewIndication;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}